import { Link } from "react-router-dom";
import { ArrowRight, CalendarClock, Presentation, Building2 } from "lucide-react";

const DEFAULT_ITEMS = [
  {
    icon: CalendarClock,
    label: "Coworking Space in Noida for a Day",
    to: "/coworking-space-in-noida-for-a-day",
    desc: "Need a desk for just a day? Book a flexible day pass — no long-term commitment.",
  },
  {
    icon: Presentation,
    label: "Conference & Meeting Rooms in Noida",
    to: "/conference-room-in-noida",
    desc: "Hourly and daily meeting rooms with AV, Wi-Fi and on-site support for your team.",
  },
  {
    icon: Building2,
    label: "Managed Office Space in Noida",
    to: "/office-space",
    desc: "Fully serviced private offices tailored to how your team works best.",
  },
];

export default function RelatedServices({
  eyebrow = "FLEXIBLE OPTIONS",
  heading = "Flexible Ways to Work in Noida",
  subheading = "Pick the workspace that fits your day — from a one-day pass to meeting rooms and managed offices.",
  items = DEFAULT_ITEMS,
}) {
  return (
    <section className="py-16 bg-slate-50 border-t border-slate-100" data-testid="related-services">
      <div className="container-cz">
        <div className="max-w-2xl mb-9">
          <p className="eyebrow mb-3">{eyebrow}</p>
          <h2 className="font-display text-3xl sm:text-4xl font-extrabold text-slate-900">{heading}</h2>
          {subheading && <p className="text-slate-500 mt-3 text-base sm:text-lg">{subheading}</p>}
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((it) => {
            const Icon = it.icon;
            return (
              <Link
                key={it.to}
                to={it.to}
                data-testid={`related-service-${it.to.replace(/\//g, "")}`}
                className="group card-cz p-6 flex flex-col hover:shadow-cz transition-all hover:-translate-y-1"
              >
                <span className="w-11 h-11 rounded-xl bg-sky-50 text-primary flex items-center justify-center mb-4">
                  <Icon className="w-5 h-5" />
                </span>
                <h3 className="font-display text-lg font-bold text-slate-900 leading-snug">{it.label}</h3>
                <p className="text-sm text-slate-500 mt-2 flex-1">{it.desc}</p>
                <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary mt-4">
                  Explore <ArrowRight className="w-4 h-4 group-hover:translate-x-0.5 transition-transform" />
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
